<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-banner>
          Destination:
        </v-banner>

        <v-list
          flat
        >
          <v-list-item-group
            v-model="destination"
          >
            <v-list-item
              value="self"
            >
              <template
                #default="{ active }"
              >
                <v-list-item-action>
                  <v-checkbox
                    :input-value="active"
                  />
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>
                    Copy within this Legal Case
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
            <v-list-item
              value="other"
            >
              <template
                #default="{ active }"
              >
                <v-list-item-action>
                  <v-checkbox
                    :input-value="active"
                  />
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>
                    Duplicate to an associated Legal Case
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
          </v-list-item-group>
        </v-list>

        <div
          v-if="destination === 'other'"
        >
          <v-banner>
            Select the destination Legal Case:
          </v-banner>

          <v-list
            flat
          >
            <v-list-item-group
              v-model="legalCaseId"
            >
              <v-list-item
                v-for="item of allowedLegalCases"
                :key="item.value"
                :value="item.value"
              >
                <template
                  #default="{ active }"
                >
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="active"
                    />
                  </v-list-item-action>

                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { alertHandler } from '@/alertHandler'

import { DOCKET_ENTRY_NAMESPACE } from '@/store/docket-entry'
import { LEGAL_CASE_NAMESPACE } from '@/store/legal-case'
import { RECORD_NAMESPACE } from '@/store/record'

export default {
  name: 'DocketEntryEditorCloningOptions',

  setup () {
    return {
      ...alertHandler(),
    }
  },

  data () {
    return {
      destination: 'self',
    }
  },

  computed: {
    allowedLegalCases () {
      return this.legalCaseOptionsList.filter(lc => lc.value !== this.originalDocketEntry.legal_case_id)
    },

    docketEntry () {
      return this.editedDocketEntry
    },

    legalCaseId: {
      get () { return this.docketEntry.legal_case_id },

      set (val) {
        if (!val) return

        this.fetchLegalCase(val).
          then(_ => {
            this.docketEntry.legal_case_id = val
          }).
          catch(error => this.displayAlert('error', null, error))
      },
    },

    ...mapGetters(DOCKET_ENTRY_NAMESPACE, [
      'editedDocketEntry',
      'originalDocketEntry',
    ]),

    ...mapGetters(LEGAL_CASE_NAMESPACE, [
      'legalCaseOptionsList',
    ]),

    ...mapGetters(RECORD_NAMESPACE, [
      'currentRecord',
    ]),
  },

  watch: {
    destination (val) {
      if (val === 'self') this.docketEntry.legal_case_id = this.originalDocketEntry.legal_case_id
      else this.docketEntry.legal_case_id = null
    },

    legalCaseId (val) {
      this.$emit('update:valid', !val)
    },
  },

  async created () {
    await this.getLegalCaseOptionsList({ id: this.currentRecord.id })
  },

  methods: {
    ...mapActions(LEGAL_CASE_NAMESPACE, [
      'fetchLegalCase',
      'getLegalCaseOptionsList',
    ]),
  },
}
</script>
